import { Link } from "react-router-dom";
import { BookOpen, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollToTopFab } from "@/components/navigation/ScrollToTopFab";
import { GuestCatalogFooter } from "@/components/guest-catalog/GuestCatalogFooter";
import { formatLibraryName } from "@/lib/utils";

interface GuestCatalogLayoutProps {
  libraryName: string;
  logoUrl?: string | null;
  children: React.ReactNode;
}

export function GuestCatalogLayout({ libraryName, logoUrl, children }: GuestCatalogLayoutProps) {
  const displayName = formatLibraryName(libraryName);

  return (
    <div className="flex min-h-screen flex-col bg-[#F8F9FA]">
      <header className="border-b bg-white">
        <div className="mx-auto flex min-h-[5rem] max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Link to="/opac" className="flex min-w-0 flex-1 items-center gap-3 sm:gap-4">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={displayName}
                className="h-12 w-auto max-w-[220px] shrink-0 object-contain sm:h-14 sm:max-w-[260px]"
              />
            ) : (
              <BookOpen
                className="h-10 w-10 shrink-0 text-primary sm:h-11 sm:w-11"
                strokeWidth={2.5}
              />
            )}
            <span className="truncate text-base font-semibold text-gray-900 sm:text-lg">
              {displayName}
            </span>
          </Link>
          <Button asChild variant="outline" size="sm" className="shrink-0">
            <Link to="/login?returnUrl=%2Fopac">
              <LogIn className="mr-2 h-4 w-4" />
              Sign in
            </Link>
          </Button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8 sm:px-6">{children}</main>
      <GuestCatalogFooter libraryName={libraryName} />
      <ScrollToTopFab />
    </div>
  );
}
